module.exports = "/_next/static/images/OilGasHero-d3476c39346a4ca20c8b9b87709a93cc.webp";